import { Data } from '../../mocks/SideBar';

export const getBreadcrumb = location =>
  Object.values(Data)
    .flat()
    .find(item => item.to === location);
